<template>
  <div class="footer" id="footer-info">
    <!-- shop_type 1: head office  0：branch office -->
    <parent-footer v-if="config.shop_type == 1" :config="config"/>
    <son-footer v-if="config.shop_type == 0" :config="config"/>
  </div>
</template>
<script>
import ParentFooter from "./ParentFooter.vue";
import SonFooter from "./SonFooter.vue";
import store from "@/store";
export default {
  components: {
    ParentFooter,
    SonFooter,
  },
  data() {
    return {};
  },
  computed: {
    config() {
      return store.state.global.configList || {};
    },
  },
  created() {},
  methods: {
    // goNextHref
    goHref(href) {
      window.open(href);
    }
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/layout/components/Footer.vue